module.exports = __webpack_public_path__ + "static/media/S47_black.10b01b29.png";